<template>
  <div
    id="range-selector"
    v-tooltip="'Selecciona el rango de alturas a desplegar en la gráfica y en el mapa.'"
  >
    <a
      class="label link r1"
      :class="{selected: value==='1'}"
      data-range="1"
      @click.prevent="emitEvent"
    >
      0 - 500
    </a>
    <a
      class="label link r2"
      :class="{selected: value==='2'}"
      data-range="2"
      @click.prevent="emitEvent"
    >
      501 - 1000
    </a>
    <a
      class="label link r3"
      :class="{selected: value==='3'}"
      data-range="3"
      @click.prevent="emitEvent"
    >
      1001 - 2000
    </a>
    <a
      class="label link r4"
      :class="{selected: value==='4'}"
      data-range="4"
      @click.prevent="emitEvent"
    >
      más de 2000
    </a>
    <a
      class="label link rall"
      :class="{selected: value==='all'}"
      data-range="all"
      @click.prevent="emitEvent"
    >
      todo
    </a>
  </div>
</template>

<script>
export default {
  name: 'RangeSelector',

  props: {
    value: {
      type: String,
      default: 'all',
      required: true,
    },
  },

  methods: {
    emitEvent(event) {
      this.$emit('input', event.target.dataset.range);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/variables';

#range-selector {
    display: grid;
    background-color: $color-clear;
    border-radius: $border-radius;
    grid-template-columns: auto auto auto auto auto;
    overflow: hidden;

    a.label {
      display: flex;
      align-items: center;
      justify-content: center;
        font-weight: bold;

        &.header {
          text-align: right;
        }

        &.selected {
          box-shadow: inset 2px 2px 3px #444;

          &.rall {
            box-shadow: inset 2px 2px 3px #000;
          }
        }
    }

    .r1 {
      background-color: $color-altitude-r1;
    }
    .r2 {
      background-color: $color-altitude-r2;
    }
    .r3 {
      background-color: $color-altitude-r3;
    }
    .r4 {
      background-color: $color-altitude-r4;
    }
    .rall {
      background-color: $color-altitude-all;
      color: $color-clear;
    }
}
</style>
